import React, { useState } from 'react';
import { BaseButton, RegularButton, Skeleton, ShoppingIcon, type RegularButtonSize } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { css, cx } from 'linaria';

export const ADD_TO_CART_BTN_QA = 'product-cart-button';

export const ProductCartButton: React.FC<{
  className?: string;
  isActive: boolean;
  isLoading: boolean;
  isBot: boolean;
  size?: RegularButtonSize;
  wide?: boolean;
  iconButtonOnMobile?: boolean;
  onClick: () => void;
}> = ({ className, size = 'm', wide, isActive, isLoading, isBot, onClick, iconButtonOnMobile }) => {
  const { t } = useTranslation();
  const [hoveredOnce, setHoveredOnce] = useState(false);

  const onMouseLeave = () => {
    if (isActive && !hoveredOnce) setHoveredOnce(true);
  };

  const commonProps = {
    'data-qa': ADD_TO_CART_BTN_QA,
    onClick,
    onMouseLeave,
  };

  const content = (
    <>
      <RegularButton
        {...commonProps}
        className={cx(className, iconButtonOnMobile ? desktopButtonStyle : mobileButtonStyle)}
        size={size}
        wide={wide}
        variant="primary"
      >
        {t('ui.button.add-to-cart')}
      </RegularButton>

      {iconButtonOnMobile && (
        <BaseButton
          type="button"
          {...commonProps}
          aria-label={t('ui.aria-label.add-to-cart')}
          className={cx(className, mobileIconStyle, mobileIconButtonStyle)}
        >
          <ShoppingIcon />
        </BaseButton>
      )}
    </>
  );

  return isLoading && !isBot ? (
    <Skeleton width="100%" variant="control">
      {content}
    </Skeleton>
  ) : (
    content
  );
};

const mobileIconStyle = css`
  display: none;

  @media (width <= 400px) {
    display: inline-flex;
  }
`;

const mobileIconButtonStyle = css`
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: var(--space-600);
  height: var(--space-600);
  padding: 0;
  border-radius: var(--rounding-m);
  background-color: var(--control-primary);

  & svg {
    width: var(--space-300);
    height: var(--space-300);
  }
`;

const mobileButtonStyle = css`
  @media (--to-desktop) {
    width: 100%;
  }
`;

const desktopButtonStyle = css`
  display: block;

  @media (width <= 400px) {
    display: none;
  }
`;
